import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'beaconstac-checkbox',
  templateUrl: './checkboxes.component.html',
  styleUrls: ['./checkboxes.component.scss']
})
export class CheckboxesComponent {


  /**
   * Checkbox label/title
   */
  @Input()
  label: string = '';

  /**
   * is checkbox disabled
   */
  @Input()
  disabled: boolean = false;

  /**
   * checkbox state
   */
  @Input()
  checked = false;

  /**
   * checkbox state event handler
   */
  @Output()
  checkedChange: EventEmitter<boolean> = new EventEmitter();

  /**
   * indeterminate checkbox state
   */

  @Input()
  indeterminate = false;

  /**
   * checkbox state event handler
   */

  @Output()
  checkboxStateHandler: EventEmitter<object> = new EventEmitter();

  change() {
    this.checked = !this.checked;
    if (this.indeterminate === true) {
      this.indeterminate = false;
    }
    this.checkedChange.emit(this.checked);
    this.checkboxStateHandler.emit({indeterminate: this.indeterminate, checked: this.checked});
  }
}
